<div class="mat-select-autocomplete-container"
  #container
  [attr.aria-labelledby]="formField?.getLabelId()"
  (focusin)="onFocusIn()"
  (focusout)="onFocusOut()">
  <input [id]="inputId"
    matInput
    appVisibilityObserver
    matAutocompleteOrigin
    #input
    #trigger="matAutocompleteTrigger"
    #origin="matAutocompleteOrigin"
    [formControl]="control"
    [matAutocomplete]="autocomplete"
    [matAutocompleteConnectedTo]="autocompleteOrigin || origin"
    (input)="onInput()"
    (visibilityChange)="onVisibilityChange($event)"
    [placeholder]="placeholder"
    [required]="required"
    [matAutocompleteDisabled]="control.disabled" />
  <mat-autocomplete #autocomplete="matAutocomplete"
    [classList]="['mat-mdc-select-autocomplete-panel']"
    [displayWith]="displayWith"
    (optionSelected)="optionSelected($event.option.value)">
    @if (!required) {
      <mat-option [value]="null">
        {{ valueFormatter(null) }}
      </mat-option>
    }
    @for (option of filteredOptions | async; track option) {
      <mat-option [value]="option">
        @switch (activeLayout) {
          @case ('textWithIcon') {
            <ng-container>{{ valueFormatter(option) }}</ng-container>
          }
          @default {
            <ng-container>
              {{ valueFormatter(option) }}
              <i [ngClass]="applyClasses(option)"></i>
            </ng-container>
          }
        }
      </mat-option>
    }
  </mat-autocomplete>
</div>
